const viewports = {
  desktop: {
    name: "Desktop",
    styles: {
      width: 1194,
      height: 834,
    },
  },
  mobile: {
    name: "Mobile",
    styles: {
      width: 360,
      height: 640,
    },
  },
  tabletLandscape: {
    name: "Tablet Landscape",
    styles: {
      width: 1024,
      height: 768,
    },
  },
  tabletPortrait: {
    name: "Tablet Portrait",
    styles: {
      width: 768,
      height: 1024,
    },
  },
};

const getViewportWidth = () => {
  const width =
    window.innerWidth ||
    document.documentElement.clientWidth ||
    document.body.clientWidth;
  return width;
};

// const getViewportHight = () => {
//   const height = window.innerHeight
//     || document.documentElement.clientHeight
//     || document.body.clientHeight;
//   return height;
// };

const isMobile = (): boolean => {
  const tabletPortraitWidth = viewports.tabletPortrait.styles.width;
  return getViewportWidth() < tabletPortraitWidth;
};
const isTabletPortrait = (): boolean => {
  const tabletPortraitWidth = viewports.tabletPortrait.styles.width;
  const tabletLandscapeWidth = viewports.tabletLandscape.styles.width;
  return (
    tabletPortraitWidth >= getViewportWidth() &&
    getViewportWidth() < tabletLandscapeWidth
  );
};
const isTabletLandscape = (): boolean => {
  const tabletLandscapeWidth = viewports.tabletLandscape.styles.width;
  const desktopWidth = viewports.desktop.styles.width;
  return (
    tabletLandscapeWidth >= getViewportWidth() &&
    getViewportWidth() <= desktopWidth
  );
};
const isDesktop = (): boolean => {
  const desktopWidth = viewports.desktop.styles.width;
  return getViewportWidth() >= desktopWidth;
};

export { isMobile, isDesktop, isTabletLandscape, isTabletPortrait, viewports };
